const configs = {
  url: 'https://nft.mewapi.io', // 'https://9bcq984094.execute-api.us-west-2.amazonaws.com/dev',
  countPerPage: 9,
  cryptoKittiesContract: '0x06012c8cf97bead5deae237070f9587f8e7a266d',
  mainnet: 'ETH'
};

export default configs;
